import React from "react";

export default function PageHero({ overline, title, subtitle, image, testId }) {
  return (
    <section
      className="relative overflow-hidden border-b border-olive/10"
      data-testid={testId || "page-hero"}
    >
      <div className="grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-7 px-6 lg:px-16 py-20 lg:py-32 flex flex-col justify-center">
          <span className="overline">{overline}</span>
          <h1 className="h-display text-5xl md:text-6xl lg:text-7xl mt-6">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-8 max-w-2xl text-lg text-olive-soft leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
        <div className="lg:col-span-5 relative min-h-[280px]">
          {image && (
            <img
              src={image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-0 bg-olive-deep/10" />
        </div>
      </div>
    </section>
  );
}
